<template>
  <div class="desp">
    <div class="desp-header">Linked Refund Orders</div>
    <div class="desp-items-group" v-for="item in detail.orderRefundList" :key="`orderRefundList-${item.id}`">
      <div class="desp-items-group-title">Refund Order</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Refund Teller</div>
              <div class="desp-item-content">{{ item.refundingTeller?.nickname || item.refundingTeller?.username || "" }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Transaction No.</div>
              <div class="blue crp desp-item-content" @click="toLinkRefundOrderDetail(item.id)">{{ item.businessNo }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Refund No.</div>
              <div class="blue crp desp-item-content" @click="invoiceLink(item.refundNo)">
                {{ item.refundNo || "" }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Refund Status</div>
              <div class="desp-item-content">
                {{ refundStatusFormat(item.status) }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Refund Create Time</div>
              <div class="desp-item-content">
                {{ item.applyTime || "" }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Apply Reason</div>
              <div class="desp-item-content">
                {{ item.applyReason || "" }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataListLoading: false,
    };
  },
  methods: {
    // 发票跳转
    invoiceLink(invoiceNumber) {
      const newPage = `${process.env.VUE_APP_URL_INVOICE}/invoice?invoiceNo=${invoiceNumber}`;
      window.open(newPage, "_blank");
    },
    // 订单详情跳转
    toLinkRefundOrderDetail(id) {
      this.$router.push(`/finance/refundOrder/${id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";
.to-link {
  cursor: pointer;
  color: #{$--color-primary};
}
</style>
